// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ayudx","footer":"Form_footer__r9zQ7"};